import { HistoryFeatureStore } from './store'
import store from 'public/store'


export function createHistoryStore (params) {
  return new HistoryFeatureStore(params)
}

export async function getHistoryValueFromStore (params, cb) {
  const {
    historyFeatureId,
    historyStore
  } = params || {}
  if (!historyStore) {
    console.error('历史结果indexDB数据库未创建，请创建!')
    return
  }
  const val = await historyStore.getItem(historyFeatureId)
  val !== null && cb(val)
}

export function setHistoryValueFromStore (params, value) {
  const {
    historyFeatureId,
    historyStore,
  } = params || {}
  if (!historyStore) {
    console.error('历史结果indexDB数据库未创建，请创建!')
    return
  }
  historyStore.setItem(historyFeatureId, value)
}

export function enableHistoryFeature (enable) {
  const lookUpOptions = store.getters.lookUpOptions || {}
  const [switchFlag] = lookUpOptions['sys_input_history_switch'] || []
  if (!switchFlag || switchFlag.value !== '1') {
    return false
  }
  if (!enable) {
    return false
  }
  return true
}



// WEBPACK FOOTER //
// ./src/public/plugins/history/index.js